import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import { getAllContactUss } from "store/actions";

import Table from "./Table";

const ContactUs = () => {
  const dispatch = useDispatch();
  const { contacts, loading, error } = useSelector((state) => state.contactUs);
  const { formatMessage, locale } = useIntl();

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  useEffect(() => {
    dispatch(getAllContactUss());
  }, [dispatch]);

  return (
    <div className="property-wrap">
      <Table data={contacts} loading={loading} />
    </div>
  );
};

export default ContactUs;
